/**
 * Test Cycle Module - Design Tokens
 * Postman-inspired QA Management SaaS design system
 */

export const SPACING = {
  xs: 0.5,   // 4px
  sm: 1,     // 8px
  md: 2,     // 16px
  lg: 3,     // 24px
  xl: 4,     // 32px
  xxl: 5,    // 40px
} as const;

export const BORDER_RADIUS = {
  sm: 1,     // 8px
  md: 2,     // 16px
  lg: 3,     // 24px
  full: '16px',
} as const;

export const ELEVATION = {
  card: '0 1px 3px rgba(0,0,0,0.06)',
  cardHover: '0 4px 12px rgba(0,0,0,0.08)',
  modal: '0 24px 48px rgba(0,0,0,0.12)',
} as const;

export const BRAND_COLORS = {
  darkBlue: '#0E185F',
  lightBlue: '#2DA7DF',
  yellow: '#F5CF17',
  pink: '#E71C6A',
  teal: '#15A9A0',
  neutral: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
} as const;

export const STATUS_COLORS = {
  pass: BRAND_COLORS.teal,
  fail: BRAND_COLORS.pink,
  inProgress: BRAND_COLORS.yellow,
  notExecuted: BRAND_COLORS.neutral[500],
} as const;

/** Progress banner with yellow-to-blue gradient (matches execution-in-progress style) */
export const PROGRESS_BANNER = {
  background: 'linear-gradient(to right, #F9D43C 0%, #70C97F 50%, #44B2ED 100%)',
  borderColor: 'rgba(68, 178, 237, 0.5)',
} as const;




